module.exports = __webpack_public_path__ + "img/emo_16.63725aaf.png";